import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Table, Alert } from 'react-bootstrap';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { useAuth } from '../context/AuthContext';
import { Helmet } from 'react-helmet';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import Titulo from '../elements/Titulo';

// Suponiendo que la API de tipo de gasto responde con un arreglo de objetos { id, nombre }


const Expense = () => {
    const { user } = useAuth();
    const [showModal, setShowModal] = useState(false);
    const [expenseTypes, setExpenseTypes] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [formData, setFormData] = useState({
        date: new Date().toISOString().slice(0, 10),
        type: "",
        description: "",
        amount: ""
    });
    const [dataResponse, setDataResponse] = useState([]);
    const category = "Gastos";
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    // Obtener tipos de gastos al cargar el componente
    useEffect(() => {
        getCategoryByType();
        getExpense();
    }, []);


    const getCategoryByType = async () => {

        getCategoryType( async (callback) => {
            await dotoniwoofApi.get(`/category.php/${callback}`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setExpenseTypes(responseApi.message);
                } else {
                    setExpenseTypes([]);
                }
            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
        });
    }

    const getCategoryType = async (callback) => {
        await dotoniwoofApi.get(`/categoryType.php/${category}`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    callback(responseApi.message[0].id_category_type);
                }

            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    }

    const getExpense = async () => {
        await dotoniwoofApi.get(`/expense.php`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setExpenses(responseApi.message);
                }
            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    };


    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await dotoniwoofApi.post("/expense.php",
                JSON.stringify({
                    firebase_UID: user.uid,
                    id_category: formData.type,
                    description: formData.description,
                    amount: formData.amount,
                    expense_date: formData.date
                }));
            setDataResponse(data);
            if (data.code === 201) {
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
                setFormData([]);
                getExpense();
            } else {
                throw new Error('Failed to save category type');
            }
        } catch (error) {
            setShowErrorAlert(true);
            setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
        }
        handleCloseModal();
    };


    return (

        <>
            <Helmet><title>
                Administracion Productos
            </title></Helmet>
            <NavContainer></NavContainer>
            <OffCanvasNav></OffCanvasNav>
            
            <div className="container mt-4">
            <Titulo>Registro de gastos</Titulo>
            <br></br>
                <Button variant="primary" onClick={handleShowModal}>
                    Registrar Gasto
                </Button>

                {/* Modal para registrar el gasto */}
                <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Registrar Gasto</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formDate">
                                <Form.Label>Fecha</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="date"
                                    value={formData.date}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                            <Form.Group controlId="formType" className="mt-3">
                                <Form.Label>Tipo de Gasto</Form.Label>
                                <Form.Select
                                    name="type"
                                    value={formData.type}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Seleccione un tipo de gasto</option>
                                    {expenseTypes.map((type) => (
                                        <option key={type.id_category} value={type.id_category}>
                                            {type.category_name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group controlId="formDescription" className="mt-3">
                                <Form.Label>Descripción</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                            <Form.Group controlId="formAmount" className="mt-3">
                                <Form.Label>Valor del Gasto</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                            <Button variant="primary" type="submit" className="mt-4">
                                Guardar Gasto
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>
                {/* Alerta de confirmación de éxito */}
                {showSuccessAlert && (
                    <Alert variant="success">
                        {dataResponse.message}
                    </Alert>
                )}
                {/* Alerta de error */}
                {showErrorAlert && (
                    <Alert variant="danger">
                        ERROR AL CREAR EL PRODUCTO
                    </Alert>
                )}
                {/* Tabla de gastos registrados */}
                <Table striped bordered hover className="mt-4">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Fecha</th>
                            <th>Tipo de Gasto</th>
                            <th>Descripción</th>
                            <th>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {expenses.map((expense) => (
                            <tr key={expense.id_expense}>
                                <td>{expense.id_expense}</td>
                                <td>{expense.expense_date}</td>
                                <td>{expense.category}</td>
                                <td>{expense.description}</td>
                                <td>$ {parseFloat(expense.amount).toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </>
    );
};

export default Expense;
